import type { Saga } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getGwpTest } from '../../services/abTestWrapper';
import {
  AB_TEST,
  gwpAbTestFailure,
  gwpAbTestRequest,
  gwpAbTestSucess,
} from '../../services/actions/abTestActions';

const { GWP_AB_TEST_TRIGGER } = AB_TEST;

// WORKER SAGA
function* fetchAbTestUserData(): Saga<void> {
  try {
    yield put(gwpAbTestRequest());
    const response = yield call(getGwpTest);
    yield put(gwpAbTestSucess(response));
  } catch (error) {
    yield put(gwpAbTestFailure(error));
  }
}

// WATCHER SAGAS
export function* watchFetchAbTestUserData(): Saga<void> {
  yield takeEvery(GWP_AB_TEST_TRIGGER, fetchAbTestUserData);
}
